###
  Initialize class on a dom elements.

  Search for a dom element with Class.ATTR_NAME attribute and pass it to
  the class constructor.

  Class must contains a static variable ATTR_NAME in order this to work.

  If class contains static variable ATTR_VALUE it would be used in a
  search selector.

  Also dom node must have a getintent.utils.Autoinit.ATTR_NAME attribute
  This attribute indicated that dom element can be autoinited

  @example How to use autoinit
    getintent.utils.Autoinit.init(someNs.MyClass);
    getintent.utils.Autoinit.init(someNs.MyClass, $(".someElement"));
###

class getintent.utils.Autoinit

  # Your dom node must have this attribute if you want to use Autoinit
  @ATTR_NAME: "data-auto-init"

  # Attribute which indicates what widget already initialized
  @ATTR_INITED: "data-autoinited"

  # Main init method
  # @param {Class}    cl        Initializing class
  # @param {jQuery}   container Container where it search for elements, default to body
  # @param {Function} initFn    Optional custom initialize function. It will receive element and a class.
  # @return {Array.<Cl instance>} Initialized instances
  @init: (cl, container, initFn)->
    unless cl.ATTR_NAME
      throw "getintent.utils.Autoinit: ATTR_NAME in class missing!"

    st = getintent.utils.Autoinit

    container = $("body") unless container?

    if cl.ATTR_VALUE?
      selector = "[#{cl.ATTR_NAME}='#{cl.ATTR_VALUE}'][#{getintent.utils.Autoinit.ATTR_NAME}]"
    else
      selector = "[#{cl.ATTR_NAME}][#{getintent.utils.Autoinit.ATTR_NAME}]"

    inited = []

    $(selector, container).each ->
      el = $(@)
      unless el.attr(st.ATTR_INITED)?
        if initFn?
          inst = initFn el, cl
          st.setInitedAttr el, cl.ATTR_NAME
        else
          inst = new cl( el )
          st.setInitedAttr el, cl.ATTR_NAME

      inited.push inst

    return inited

  # Sets attribute on element which indicates what element is initialized
  # @param {jQuery} el Element on which set attribute
  # @param String aName attribute name of initializable
  @setInitedAttr: (el, aName) =>
    if 'init-continue' != el.attr(aName)
      el.attr getintent.utils.Autoinit.ATTR_INITED, true

  # Wait for dom ready event and init after it
  # @param {Class}    cl        Initializing class
  # @param {jquery}   container Container where it search for elements, default to body
  # @param {Function} initFn    Optional custom initialize function. It will receive element and a class.
  @initAfterDom: (cl, container, initFn)->
    $ -> getintent.utils.Autoinit.init(cl, container)